import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg, fileUrl } from "@/lib/api";
import { inputCls } from "@/pages/Login";

const TOGGLES = [
  ["uploads_enabled", "Nalaganje gostov", "Gostje lahko dodajajo fotografije in videe."],
  ["gallery_public", "Galerija vidna gostom", "Gostje vidijo vse odobrene fotografije in videe."],
  ["guest_downloads", "Prenos za goste", "Gostje lahko prenesejo posamezne datoteke."],
  ["reactions_enabled", "Srčki", "Gostje lahko všečkajo fotografije."],
  ["guestbook_enabled", "Knjiga gostov", "Gostje lahko zapišejo sporočilo za vaju."],
];

export default function SettingsPanel({ wedding, onSaved }) {
  const [f, setF] = useState({ title: wedding.title, partner1: wedding.partner1, partner2: wedding.partner2, wedding_date: wedding.wedding_date, welcome_message: wedding.welcome_message, thank_you_message: wedding.thank_you_message });
  const [busy, setBusy] = useState(false);

  const save = async (body) => {
    setBusy(true);
    try {
      const r = await api.patch(`/manage/weddings/${wedding.id}`, body);
      onSaved(r.data);
      toast.success("Shranjeno.");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const cover = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await api.post(`/manage/weddings/${wedding.id}/cover`, fd);
      onSaved({ ...wedding, cover_url: r.data.cover_url });
      toast.success("Naslovna fotografija je posodobljena.");
    } catch (er) { toast.error(errMsg(er)); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="settings-panel">
      <form onSubmit={(e) => { e.preventDefault(); save(f); }} className="card-lux p-6 space-y-4">
        <h3 className="font-display text-2xl">Podatki o poroki</h3>
        <label className="block text-sm text-[#6C6560]">Naslov galerije<input className={`${inputCls} mt-1`} value={f.title} onChange={set("title")} data-testid="settings-title-input" /></label>
        <div className="grid grid-cols-2 gap-3">
          <label className="block text-sm text-[#6C6560]">Ime 1<input className={`${inputCls} mt-1`} value={f.partner1} onChange={set("partner1")} data-testid="settings-partner1-input" /></label>
          <label className="block text-sm text-[#6C6560]">Ime 2<input className={`${inputCls} mt-1`} value={f.partner2} onChange={set("partner2")} data-testid="settings-partner2-input" /></label>
        </div>
        <label className="block text-sm text-[#6C6560]">Datum poroke<input type="date" className={`${inputCls} mt-1`} value={f.wedding_date} onChange={set("wedding_date")} data-testid="settings-date-input" /></label>
        <label className="block text-sm text-[#6C6560]">Pozdravno sporočilo<textarea rows={2} maxLength={400} className={`${inputCls} h-auto py-3 mt-1`} value={f.welcome_message} onChange={set("welcome_message")} data-testid="settings-welcome-input" /></label>
        <label className="block text-sm text-[#6C6560]">Zahvala po nalaganju<textarea rows={2} maxLength={400} className={`${inputCls} h-auto py-3 mt-1`} value={f.thank_you_message} onChange={set("thank_you_message")} data-testid="settings-thankyou-input" /></label>
        <button disabled={busy} className="btn-dark px-6 h-11 disabled:opacity-50" data-testid="settings-save-button">Shrani</button>
      </form>
      <div className="space-y-6">
        <div className="card-lux p-6 space-y-4">
          <h3 className="font-display text-2xl">Naslovna fotografija</h3>
          {wedding.cover_url && <img src={fileUrl(wedding.cover_url)} alt="" className="w-full h-44 object-cover rounded-xl" data-testid="settings-cover-preview" />}
          <label className="btn-line px-5 py-2.5 text-sm inline-block cursor-pointer" data-testid="settings-cover-upload">Naloži fotografijo<input type="file" accept="image/*,.heic" className="hidden" onChange={cover} data-testid="settings-cover-input" /></label>
        </div>
        <div className="card-lux p-6 space-y-1">
          <h3 className="font-display text-2xl mb-3">Možnosti galerije</h3>
          {TOGGLES.map(([k, l, d]) => (
            <div key={k} className="flex items-center justify-between gap-4 py-3 border-b border-[#EADBCE]/60 last:border-0">
              <div><p className="text-sm font-medium">{l}</p><p className="text-xs text-[#6C6560]">{d}</p></div>
              <Switch checked={!!wedding.settings[k]} onCheckedChange={(v) => save({ settings: { [k]: v } })} data-testid={`settings-toggle-${k}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
